import React from 'react';
import { Grid } from '@mui/material';
import { CompletedCompetition } from '../CompletedCompetition';
import { ICompletedCompetitionsGrid } from './interfaces';

export const CompletedCompetitionsGrid: React.FC<ICompletedCompetitionsGrid> = ({
  competitions,
}): JSX.Element => {
  return (
    <Grid container spacing="15px">
      {competitions.map((competition) => {
        return (
          <Grid item xs={4} key={competition.slug}>
            <CompletedCompetition {...competition} />
          </Grid>
        );
      })}
    </Grid>
  );
};
